import React from 'react';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Slider from '@mui/material/Slider';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {
  marks,
  API_URL_NEW_TENDER,
  API_BASE_URL,
  API_URL_EDIT,
  API_URL_RESPONSIBLE_CONTACTS,
  API_URL_TENDER_MANUAL_DEPARTMENTS,
  formatResponsibleContact,
  getResponsibleContactOptions,
  setResponsibleContactOptions,
} from '../../configuration/Configuration';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import ColumnCreator from '../custom_column/ColumnCreator';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
//var tenderStatus = false;
import { useEffect } from 'react';

// Configure dayjs plugins for timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

const SELECT_ALL_VALUE = '__select_all__';

const TenderData = (props) => {
  const [date, setDate] = React.useState('');
  const [date1, setDate1] = React.useState('');
  const [date2, setDate2] = React.useState('');
  const [date3, setDate3] = React.useState('');

  const [state, setState] = React.useState('');
  const handleStateChange = (event) => {
    setState(event.target.value);
  };
  const [state2, setState2] = React.useState('');
  const handleStateChange2 = (event) => {
    setState2(event.target.value);
  };
  const [state3, setState3] = React.useState('');
  const handleStateChange3 = (event) => {
    setState3(event.target.value);
  };

  const [state4, setState4] = React.useState('');
  const handleStateChange4 = (event) => {
    setState4(event.target.value);
  };
  const [capacityRequired, setCapacityRequired] = React.useState(false);
  const handleCapacityRequiredChange = () => {
    if (!capacityRequired && !state4) {
      setState4('daily');
    }
    setCapacityRequired(!capacityRequired);
  };

  const [infoCapacity, setInfoCapacity] = React.useState(false);
  const handleInfoCapacityChange = () => {
    setInfoCapacity(!infoCapacity);
  };
  const [tenderInformation, setTenderInformation] = React.useState('');
  const handleTenderInformationChange = (event) => {
    setTenderInformation(event.target.value);
  };
  const [responsiblePerson, setResponsiblePerson] = React.useState('');
  const [responsibleContacts, setResponsibleContacts] = React.useState(
    getResponsibleContactOptions()
  );
  const handleResponsiblePersonChange = (event) => {
    setResponsiblePerson(event.target.value);
  };
  const [fillingNotes, setFillingNotes] = React.useState('');
  const handleFillingNotesChange = (event) => {
    setFillingNotes(event.target.value);
  };

  const [state5, setState5] = React.useState(false);
  const handleStateChange5 = (event) => {
    setState5(!state5);
  };
  const [state6, setState6] = React.useState(false);
  const handleStateChange6 = (event) => {
    setState6(!state6);
  };

  const [state8, setState8] = React.useState(false);
  const handleStateChange8 = (event) => {
    setState8(!state8);
  };

  const [state7, setState7] = React.useState(false);
  const handleStateChange7 = (event) => {
    setState7(!state7);
  };

  // Transit time type state
  const [transitTimeType, setTransitTimeType] = React.useState('days');
  const handleTransitTimeTypeChange = (event) => {
    setTransitTimeType(event.target.value);
  };

  // Additional costs type state
  const [additionalCostsType, setAdditionalCostsType] =
    React.useState('absolute');
  const handleAdditionalCostsTypeChange = (event) => {
    setAdditionalCostsType(event.target.value);
  };

  const formatDateOnlyForUpdate = (value) => {
    if (!value) {
      return null;
    }

    const parsedValue = dayjs(value);
    return parsedValue.isValid() ? parsedValue.format('YYYY-MM-DD') : null;
  };

  // Department selection state
  const [availableDepartments, setAvailableDepartments] = React.useState([]);
  const [selectedDepartments, setSelectedDepartments] = React.useState([]);
  const [allLanesDepartmentIds, setAllLanesDepartmentIds] = React.useState([]);

  const handleDepartmentChange = (event) => {
    const {
      target: { value },
    } = event;
    let selectedDepartmentIds =
      typeof value === 'string' ? value.split(',') : value;
    if (selectedDepartmentIds.includes(SELECT_ALL_VALUE)) {
      selectedDepartmentIds =
        selectedDepartments.length === availableDepartments.length
          ? []
          : availableDepartments.map((dept) => dept.id);
    }
    setSelectedDepartments(selectedDepartmentIds);
    setAllLanesDepartmentIds((current) =>
      selectedDepartmentIds.length > 0
        ? current.filter((departmentId) => selectedDepartmentIds.includes(departmentId))
        : current
    );
  };

  const handleAllLanesDepartmentChange = (event) => {
    const {
      target: { value },
    } = event;
    const allLanesDepartmentIds =
      typeof value === 'string' ? value.split(',') : value;
    setAllLanesDepartmentIds(allLanesDepartmentIds);
  };

  // Track previous state to detect when requirements are newly enabled
  const [prevRequirements, setPrevRequirements] = React.useState({
    transitTime: false,
    additionalCosts: false,
    additionalData: false,
    margin: false,
    transitTimeType: 'days',
  });

  // Auto-generate filling instructions based on settings
  const generateFillingInstructions = () => {
    let instructions = [];

    const capacityLabelMap = {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      percentage: 'Percentage',
    };
    const capacityLabel = capacityLabelMap[state4] || '';

    // Transit Time instructions based on type
    if (state7) {
      // Transit time required
      if (transitTimeType === 'intervals') {
        instructions.push(
          '📅 Transit Time Format: Please enter transit times using intervals format: A–B, A–C, etc.'
        );
      } else if (transitTimeType === 'hours') {
        instructions.push(
          '⏰ Transit Time Format: Please enter transit times in hours.\nExample: 24, 48, 72'
        );
      } else {
        instructions.push(
          '📆 Transit Time Format: Please enter transit times in days.\nExample: 1, 2, 3'
        );
      }
    }

    // Capacity instructions
    if (capacityRequired && capacityLabel) {
      instructions.push(
        `📦 Capacity Type: Selected capacity is ${capacityLabel}. Please fill the capacity column accordingly.`
      );
    }

    // Additional Costs instructions
    if (state5) {
      // Additional costs required
      if (additionalCostsType === 'percent') {
        instructions.push(
          '💰 Additional Costs (Percentage): Please provide additional costs as percentages.\nExample: 5, 10, 15'
        );
      } else {
        instructions.push(
          '💰 Additional Costs (Absolute): Please provide additional costs as absolute amounts in euros.\nExample: 50, 100, 150'
        );
      }
    }

    // Additional Data instructions
    if (state8) {
      // Additional data required
      instructions.push(
        '📋 Additional Data: Please provide all additional data as specified in the tender requirements.'
      );
    }

    // Margin instructions
    if (state6) {
      // Margin required
      instructions.push(
        '📊 Margin Requirements: Please specify your margin percentage for each lane.'
      );
    }

    // Add general note if any requirements are selected
    if (instructions.length > 0) {
      instructions.unshift('FILLING INSTRUCTIONS');
      instructions.push(
        '⚠️ Important: All marked fields are required for submission. Incomplete entries will delay processing.'
      );
    }

    return instructions.join('\n\n');
  };

  // Update filling notes when settings change
  React.useEffect(() => {
    const currentRequirements = {
      transitTime: state7,
      additionalCosts: state5,
      additionalData: state8,
      margin: state6,
      capacity: capacityRequired ? state4 : '',
      capacityRequired: capacityRequired,
      transitTimeType: transitTimeType,
    };

    const autoInstructions = generateFillingInstructions();
    const currentNotes = (fillingNotes || '').trim();
    const hasAuto = currentNotes.includes('FILLING INSTRUCTIONS');

    // If no auto instructions are needed anymore, remove existing auto section
    if (!autoInstructions) {
      if (hasAuto) {
        const lines = currentNotes.split('\n');
        const startIndex = lines.findIndex((line) =>
          line.includes('FILLING INSTRUCTIONS')
        );
        if (startIndex !== -1) {
          // Find end of auto block: look for the sentinel line '⚠️ Important' included, then subsequent blank line
          const endIndex = lines.findIndex(
            (line, idx) => idx > startIndex && line.includes('⚠️ Important')
          );
          const afterIndex = endIndex !== -1 ? endIndex + 1 : startIndex;
          const beforeAuto = lines.slice(0, startIndex).join('\n').trim();
          const afterAuto = lines
            .slice(afterIndex + 1)
            .join('\n')
            .trim();
          const manualNotes = [beforeAuto, afterAuto]
            .filter(Boolean)
            .join('\n\n');
          setFillingNotes(manualNotes);
        }
      }
    } else {
      // There are auto instructions to insert/update
      if (hasAuto) {
        // Replace existing auto block with updated autoInstructions
        const lines = currentNotes.split('\n');
        const startIndex = lines.findIndex((line) =>
          line.includes('FILLING INSTRUCTIONS')
        );
        if (startIndex !== -1) {
          const endIndex = lines.findIndex(
            (line, idx) => idx > startIndex && line.includes('⚠️ Important')
          );
          const afterIndex = endIndex !== -1 ? endIndex + 1 : startIndex;
          const beforeAuto = lines.slice(0, startIndex).join('\n').trim();
          const afterAuto = lines
            .slice(afterIndex + 1)
            .join('\n')
            .trim();
          const manualNotes = [beforeAuto, afterAuto]
            .filter(Boolean)
            .join('\n\n');
          const newNotes = manualNotes
            ? autoInstructions + '\n\n' + manualNotes
            : autoInstructions;
          setFillingNotes(newNotes);
        } else {
          // Fallback: just set autoInstructions
          setFillingNotes(
            autoInstructions + (currentNotes ? '\n\n' + currentNotes : '')
          );
        }
      } else {
        // No existing auto content: auto-fill (prepend) but keep manual notes
        if (!currentNotes) {
          setFillingNotes(autoInstructions);
        } else {
          // If manual-only notes exist, prepend auto instructions so they are visible
          setFillingNotes(autoInstructions + '\n\n' + currentNotes);
        }
      }
    }

    setPrevRequirements(currentRequirements);
  }, [
    transitTimeType,
    additionalCostsType,
    capacityRequired,
    state4,
    state5,
    state6,
    state7,
    state8,
  ]);

  // appendAutoInstructions removed — filling notes are now updated automatically by useEffect

  const [prio, setPrio] = React.useState(2);
  const handlePrioChange = (event) => {
    setPrio(event.target.value);
  };

  // Fetch available departments on component mount
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const tempUser = localStorage.getItem('user');
        const response = await axios.get(
          `${API_BASE_URL}/api/departments/${tempUser}`
        );
        setAvailableDepartments(response.data);
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    const fetchResponsibleContacts = async () => {
      try {
        const response = await axios.get(API_URL_RESPONSIBLE_CONTACTS);
        setResponsibleContactOptions(response.data);
        setResponsibleContacts(getResponsibleContactOptions());
      } catch (error) {
        console.error('Error fetching responsible contacts:', error);
        setResponsibleContacts(getResponsibleContactOptions());
      }
    };

    fetchResponsibleContacts();
  }, []);

  useEffect(() => {
    if (props.tenderDataState) {
      const internalDeadline = props.tenderDataState?.date;
      if (internalDeadline) {
        const parsedInternalDeadline = dayjs(internalDeadline);
        setDate(
          parsedInternalDeadline.isValid() ? parsedInternalDeadline : ''
        );
      } else {
        setDate(internalDeadline);
      }

      // Parse regular dates
      setDate1(
        props.tenderDataState?.date1 ? dayjs(props.tenderDataState.date1) : ''
      );
      setDate2(
        props.tenderDataState?.date2 ? dayjs(props.tenderDataState.date2) : ''
      );
      setDate3(
        props.tenderDataState?.date3 ? dayjs(props.tenderDataState.date3) : ''
      );

      setPrio(props.tenderDataState?.prio ?? 2);
      setState(props.tenderDataState?.state);
      setState2(props.tenderDataState?.state2 ?? '');
      setState3(props.tenderDataState?.state3 || '');
      setState4(props.tenderDataState?.state4);
      setCapacityRequired(
        props.tenderDataState?.capacityRequired ??
          Boolean(props.tenderDataState?.state4)
      );
      setInfoCapacity(props.tenderDataState?.infoCapacity ?? false);
      setState5(props.tenderDataState?.state5);
      setState6(props.tenderDataState?.state6);
      setState7(props.tenderDataState?.state7);
      setState8(props.tenderDataState?.state8);
      setTenderInformation(props.tenderDataState?.tenderInformation || '');
      setResponsiblePerson(props.tenderDataState?.responsiblePerson || '');
      setFillingNotes(props.tenderDataState?.fillingNotes || '');
      setSelectedDepartments(props.tenderDataState?.selectedDepartments || []);
      setAllLanesDepartmentIds(
        props.tenderDataState?.allLanesDepartmentIds || []
      );
      setTransitTimeType(props.tenderDataState?.transitTimeType || 'days');
      setAdditionalCostsType(
        props.tenderDataState?.additionalCostsType || 'absolute'
      );

      // Initialize previous requirements state when loading saved data
      setPrevRequirements({
        transitTime: props.tenderDataState?.state7 || false,
        additionalCosts: props.tenderDataState?.state5 || false,
        additionalData: props.tenderDataState?.state8 || false,
        margin: props.tenderDataState?.state6 || false,
        transitTimeType:
          props.tenderDataState?.transitTimeType || transitTimeType,
      });
    }
  }, [props.tenderDataState]);

  const postTender = async () => {
    props.setTenderDataState({
      prio: prio,
      date: date,
      date1: date1,
      date2: date2,
      date3: date3,
      state: state,
      state2: state2,
      state3: state3,
      state4: state4,
      capacityRequired: capacityRequired,
      infoCapacity: infoCapacity,
      state5: state5,
      state6: state6,
      state7: state7,
      state8: state8,
      tenderInformation: tenderInformation,
      responsiblePerson: responsiblePerson,
      fillingNotes: fillingNotes,
      customerNotificationEmails: props.customerNotificationEmails || [],
      selectedDepartments: selectedDepartments,
      allLanesDepartmentIds: allLanesDepartmentIds,
      transitTimeType: transitTimeType,
      additionalCostsType: additionalCostsType,
    });
    const capacityData = {
      capacity: capacityRequired ? state4 : '',
      transit_time_type: transitTimeType,
    };

    // Use the update path when editing an existing tender OR when navigating back
    // to this step after already creating a tender in the current wizard session.
    const existingTenderId = props.editTenderId || props.createdTenderId || null;

    if (existingTenderId) {
      const updatePayload = {
        company_id: props.customer,
        priority: prio,
        internalDeadline: date ? dayjs(date).toISOString() : null,
        submissionDate: formatDateOnlyForUpdate(date1),
        contractStart: formatDateOnlyForUpdate(date2),
        contractEnd: formatDateOnlyForUpdate(date3),
        invoicing: state || null,
        paymentTerms: state2 === '' ? null : Number(state2),
        link: state3 || '',
        requested_capacity: JSON.stringify(capacityData),
        capacity_required: capacityRequired,
        info_capacity: infoCapacity,
        transit_time_required: state7,
        additional_costs_required: state5,
        additional_costs_type: additionalCostsType,
        additional_data_required: state8,
        margin_required: state6,
        tender_information: tenderInformation || '',
        responsible_person: responsiblePerson || '',
        filling_notes: fillingNotes || '',
        customer_notification_emails: props.customerNotificationEmails || [],
        customColumnsMetadata: [...(props.infoCustomColumns || []), ...(props.customColumns || [])],
      };

      try {
        const editResponse = await axios.post(`${API_URL_EDIT}tender`, {
          [existingTenderId]: updatePayload,
        });

        if (props.canEditDepartments) {
          await axios.post(
            API_URL_TENDER_MANUAL_DEPARTMENTS(
              existingTenderId,
              props.username
            ),
            {
              selected_departments: selectedDepartments,
              all_lanes_department_ids: allLanesDepartmentIds,
            },
            { withCredentials: true }
          );
        }

        const notice = editResponse?.data?._notice;
        if (notice) {
          alert(notice);
        }

        props.func({
          tenderID: { pk__max: Number(existingTenderId) },
        });
        props.handleNext();
      } catch (error) {
        console.error('Error updating tender', error);
        alert(
          error.response?.data?.message ||
            error.response?.data?.detail ||
            error.response?.data?.error ||
            'An error occurred while updating the tender.'
        );
      }

      return;
    }

    // Create an object of formData
    const tenderData = new FormData();
    // Update the formData object
    tenderData.append('company', props.customer);
    tenderData.append('priority', prio);

    // Format internal deadline datetime properly with timezone
    if (date !== '') {
      // Backend expects Austrian timezone context (Django TIME_ZONE = "Europe/Vienna")
      // Convert user's local time to Austrian timezone, then format for backend
      const austrianTime = date.tz('Europe/Vienna');

      // Format in the way backend expects: "%a, %d %b %Y %H:%M:%S %Z"
      const formattedDate =
        austrianTime.locale('en').format('ddd, DD MMM YYYY HH:mm:ss') + ' GMT';

      tenderData.append('internal_deadline', formattedDate);
    } else {
      tenderData.append('internal_deadline', '');
    }
    // Format submission date properly
    if (date1 !== '') {
      // Convert to the format expected by Django backend (adding default time)
      // Force English locale for backend compatibility
      const formattedDate1 =
        dayjs(date1).locale('en').format('ddd, DD MMM YYYY') + ' 00:00:00 GMT';
      tenderData.append('submission_date', formattedDate1);
    } else {
      tenderData.append('submission_date', '');
    }
    // Format contract start date properly
    const formattedDate2 =
      dayjs(date2).locale('en').format('ddd, DD MMM YYYY') + ' 00:00:00 GMT';
    tenderData.append('contract_start', formattedDate2);

    // Format contract end date properly
    const formattedDate3 =
      dayjs(date3).locale('en').format('ddd, DD MMM YYYY') + ' 00:00:00 GMT';
    tenderData.append('contract_end', formattedDate3);

    tenderData.append('invoicing', state);
    tenderData.append('payment_terms', state2);
    tenderData.append('file_directory', state3);

    // Store capacity and transit time type as JSON
    tenderData.append('requested_capacity', JSON.stringify(capacityData));
    tenderData.append('capacity_required', capacityRequired);
    tenderData.append('info_capacity', infoCapacity);

    tenderData.append('transit_time_required', state7);
    tenderData.append('additional_costs_required', state5);
    tenderData.append('additional_costs_type', additionalCostsType);
    tenderData.append('additional_data_required', state8);

    tenderData.append('margin_required', state6);
    tenderData.append('tender_information', tenderInformation);
    tenderData.append('responsible_person', responsiblePerson);
    tenderData.append('filling_notes', fillingNotes);
    tenderData.append(
      'customer_notification_emails',
      JSON.stringify(props.customerNotificationEmails || [])
    );

    // Add selected departments as JSON array
    tenderData.append(
      'selected_departments',
      JSON.stringify(selectedDepartments)
    );
    tenderData.append(
      'all_lanes_department_ids',
      JSON.stringify(allLanesDepartmentIds)
    );

    await axios
      .post(API_URL_NEW_TENDER, tenderData)
      .then((res) => {
        props.func(res.data);
        props.handleNext();
      })
      .then(console.log('tender posted', tenderData));
  };

  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{ mt: 5 }}
        justify="flex-start"
        alignItems="center"
      >
        <Grid item xs={2} justifyContent="flex-start">
          <Typography align="left" sx={{ mt: 2, mb: 1 }}>
            Tender Priority
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <Slider
            aria-label="prioslider"
            valueLabelDisplay="auto"
            onChange={handlePrioChange}
            value={prio}
            sx={{ width: '65%' }}
            step={1}
            marks={marks}
            min={1}
            max={3}
          />
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography align="left" sx={{ mt: 2, mb: 1 }}>
            Internal Deadline
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
            <DateTimePicker
              value={date}
              onChange={setDate}
              sx={{ width: '65%' }}
              label="Date & Time (Date Required)"
              format="DD.MM.YYYY HH:mm"
              ampm={false}
              slotProps={{
                textField: {
                  helperText:
                    'Time shown in 24h format and in your timezone. 00:00 = midnight',
                  required: true,
                },
              }}
            />
          </LocalizationProvider>
          {date !== '' && date2 !== '' && dayjs(date).isAfter(dayjs(date2)) && (
            <p className="input-error">
              Internal Deadline must be before Contract Start!
            </p>
          )}
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Tender Submission Until
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
            <DatePicker
              value={date1}
              onChange={setDate1}
              label={'Required'}
              sx={{ width: '65%' }}
            />
          </LocalizationProvider>
          {date1 !== '' &&
            date2 !== '' &&
            dayjs(date1).isAfter(dayjs(date2)) && (
              <p className="input-error">
                Submission must be before Contract Start!
              </p>
            )}
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Contract Start
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
            <DatePicker
              value={date2}
              onChange={setDate2}
              label={'Required'}
              sx={{ width: '65%' }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Contract End
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
            <DatePicker
              value={date3}
              onChange={setDate3}
              label={'Required'}
              sx={{ width: '65%' }}
            />
          </LocalizationProvider>
          {date2 !== '' &&
            date3 !== '' &&
            dayjs(date2).isAfter(dayjs(date3)) && (
              <p className="input-error">
                Contract Start must be before Contract End!
              </p>
            )}
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Invoicing
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <Select
            value={state}
            label=""
            sx={{ width: '65%' }}
            onChange={handleStateChange}
          >
            <MenuItem value={'ImmediateSingle'}>Immediate Single</MenuItem>
            <MenuItem value={'WeeklyCollective'}>Weekly Collective</MenuItem>
            <MenuItem value={'BiweeklyCollective'}>
              Biweekly Collective
            </MenuItem>
            <MenuItem value={'MonthlyCollective'}>Monthly Collective</MenuItem>
            {/* <MenuItem value={"MonthlyIndividually"}>Monthly Individually</MenuItem> */}
            {/* <MenuItem value={"AnnuallyIndividually"}>Annually Individually</MenuItem>
          <MenuItem value={"AnnuallyCollective"}>Annually Collective</MenuItem> */}
          </Select>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Payment Terms
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <TextField
            id="filled-basic"
            onChange={handleStateChange2}
            value={state2}
            type="number"
            label="(in Days)"
            sx={{ width: '65%' }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Tender Title
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <TextField
            id="tender-information"
            onChange={handleTenderInformationChange}
            value={tenderInformation}
            multiline
            rows={3}
            label="Additional information about this tender"
            sx={{ width: '65%' }}
            variant="filled"
            placeholder="Enter any additional information that helps distinguish this tender from others for the same customer"
          />
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Responsible Contact
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <Select
            value={responsiblePerson}
            displayEmpty
            required
            error={responsiblePerson === ''}
            sx={{ width: '65%' }}
            onChange={handleResponsiblePersonChange}
          >
            <MenuItem value="" disabled>
              <em>Select a responsible contact (Required)</em>
            </MenuItem>
            {responsibleContacts.map(({ email, display_name }) => (
              <MenuItem key={email} value={email}>
                {formatResponsibleContact(email, display_name)}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Filling Instructions
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <TextField
            id="filling-notes"
            onChange={handleFillingNotesChange}
            value={fillingNotes}
            multiline
            rows={4}
            label="Instructions for department users on how to fill this tender"
            sx={{ width: '65%' }}
            variant="filled"
            placeholder="Enter specific instructions for department users (e.g., pricing guidelines, margin requirements, special considerations)"
          />
        </Grid>
        {/* Auto-Generate button removed: filling instructions are auto-populated and updated */}
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>
        {/* TODO decide if we want to include customer notifications here */}
        {/* <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Customer Notifications
          </Typography>
        </Grid> */}
        {/* <Grid item xs={4} align="left">
          <TextField
            value={(props.customerNotificationEmails || []).join(', ')}
            label="Selected customer recipients"
            sx={{ width: '65%' }}
            variant="filled"
            InputProps={{ readOnly: true }}
            helperText="Managed on the customer step. Selected emails will be notified when the tender is published."
          />
        </Grid> */}
        {/* <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid> */}

        {/* Department Selection */}
        <Grid item xs={2}>
          <Typography sx={{ mt: 2, mb: 1 }} align="left">
            Visible to Departments
          </Typography>
        </Grid>
        <Grid item xs={4} align="left">
          <FormControl
            sx={{ width: '65%' }}
            disabled={props.canEditDepartments === false}
          >
            <InputLabel id="department-select-label">
              Select Departments
            </InputLabel>
            <Select
              labelId="department-select-label"
              id="department-select"
              multiple
              value={selectedDepartments}
              onChange={handleDepartmentChange}
              input={<OutlinedInput label="Select Departments" />}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return <em>All departments (based on lane settings)</em>;
                }
                return availableDepartments
                  .filter((dept) => selected.includes(dept.id))
                  .map((dept) => dept.name)
                  .join(', ');
              }}
            >
              <MenuItem disabled value="">
                <em>Select departments that should see this tender</em>
              </MenuItem>
              {availableDepartments.length > 0 && (
                <MenuItem value={SELECT_ALL_VALUE}>
                  <Checkbox
                    checked={
                      selectedDepartments.length === availableDepartments.length
                    }
                    indeterminate={
                      selectedDepartments.length > 0 &&
                      selectedDepartments.length < availableDepartments.length
                    }
                  />
                  <ListItemText primary="Select all" />
                </MenuItem>
              )}
              {availableDepartments.map((dept) => (
                <MenuItem key={dept.id} value={dept.id}>
                  <Checkbox
                    checked={selectedDepartments.indexOf(dept.id) > -1}
                  />
                  <ListItemText primary={dept.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            {props.canEditDepartments === false
              ? 'Only tender managers can change department visibility.'
              : 'Leave empty to use automatic department assignment based on lane settings. Select specific departments to override and show tender to only those.'}
          </Typography>
          <FormControl
            sx={{ width: '65%', mt: 1 }}
            disabled={props.canEditDepartments === false}
          >
            <InputLabel id="all-lanes-department-select-label">
              Lane access
            </InputLabel>
            <Select
              labelId="all-lanes-department-select-label"
              id="all-lanes-department-select"
              multiple
              value={allLanesDepartmentIds}
              onChange={handleAllLanesDepartmentChange}
              input={<OutlinedInput label="Lane access" />}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return <em>No departments</em>;
                }
                return availableDepartments
                  .filter((dept) => selected.includes(dept.id))
                  .map((dept) => dept.name)
                  .join(', ');
              }}
            >
              {availableDepartments
                .filter((dept) =>
                  selectedDepartments.length > 0
                    ? selectedDepartments.includes(dept.id)
                    : true
                )
                .map((dept) => (
                  <MenuItem key={dept.id} value={dept.id}>
                    <Checkbox
                      checked={allLanesDepartmentIds.includes(dept.id)}
                    />
                    <ListItemText primary={dept.name} />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Selected departments can access every lane.
          </Typography>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}></Grid>

        <Grid item xs={1}></Grid>

        {/* Configure Columns: two-panel layout */}
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography sx={{ mb: 2 }} align="left" fontWeight={600}>
            Configure columns
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            {/* Information columns panel */}
            <Grid item xs={6}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderColor: '#1976d2',
                  borderWidth: 2,
                  borderRadius: 2,
                  height: '100%',
                }}
              >
                <Typography
                  sx={{ mb: 1, color: '#1976d2' }}
                  fontWeight={600}
                  align="left"
                >
                  Information Columns
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, display: 'block', color: 'text.secondary', justifySelf: 'flex-start' }}>
                  Read-Only reference shown to department
                </Typography>

                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  sx={{ width: 'auto', textAlign: 'start' }}
                >
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleInfoCapacityChange}
                          checked={infoCapacity}
                          name="info_capacity"
                        />
                      }
                      label="Capacity"
                    />
                  </Grid>

                  {/* Info panel custom columns */}
                  {props.infoCustomColumns &&
                    props.infoCustomColumns.length > 0 &&
                    props.infoCustomColumns.map((column, index) => {
                      const columnName =
                        typeof column === 'string' ? column : column.name;
                      return (
                        <Grid item xs={12} key={index}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography align="left">{columnName}</Typography>
                            <Button
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={() => {
                                const updated = [...props.infoCustomColumns];
                                updated.splice(index, 1);
                                props.setInfoCustomColumns(updated);
                              }}
                              sx={{ minWidth: '60px' }}
                            >
                              Delete
                            </Button>
                          </Box>
                        </Grid>
                      );
                    })}

                  <Grid item xs={12} sx={{ mt: 1 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => props.setOpenInfo()}
                    >
                      + Add column
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Input columns panel */}
            <Grid item xs={6}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderColor: '#1976d2',
                  borderWidth: 2,
                  borderRadius: 2,
                  height: '100%',
                }}
              >
                <Typography
                  sx={{ mb: 1, color: '#1976d2' }}
                  fontWeight={600}
                  align="left"
                >
                  Input Columns
                </Typography>
                <Typography variant="caption" sx={{ mb: 2, display: 'block', color: 'text.secondary', justifySelf: 'flex-start' }}>
                  Fields departments are required to fill in
                </Typography>

                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  sx={{ width: 'auto', textAlign: 'start' }}
                >
                  {/* Capacity */}
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleCapacityRequiredChange}
                            checked={capacityRequired}
                            name="capacity_required"
                          />
                        }
                        label="Capacity"
                      />
                      {capacityRequired && (
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                          <InputLabel>Type</InputLabel>
                          <Select
                            value={state4}
                            label="Type"
                            onChange={handleStateChange4}
                          >
                            <MenuItem value={'daily'}>Daily</MenuItem>
                            <MenuItem value={'weekly'}>Weekly</MenuItem>
                            <MenuItem value={'monthly'}>Monthly</MenuItem>
                            <MenuItem value={'yearly'}>Yearly</MenuItem>
                            <MenuItem value={'percentage'}>Percentage</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>

                  {/* Transit Time */}
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleStateChange7}
                            checked={state7}
                            name="transit_time_required"
                          />
                        }
                        label="Transit Time"
                      />
                      {state7 && (
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                          <InputLabel>Type</InputLabel>
                          <Select
                            value={transitTimeType}
                            label="Type"
                            onChange={handleTransitTimeTypeChange}
                          >
                            <MenuItem value={'days'}>Days</MenuItem>
                            <MenuItem value={'intervals'}>Intervals (A–B)</MenuItem>
                            <MenuItem value={'hours'}>Hours</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>

                  {/* Input panel custom columns */}
                  <ColumnCreator
                    setOpen={props.setOpenInput}
                    customColumns={props.customColumns}
                    setCustomColumns={props.setCustomColumns}
                  />
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}></Grid>

        <Grid item xs={2} align="left">
          {date !== '' &&
            date2 !== '' &&
            date3 !== '' &&
            responsiblePerson !== '' &&
            !dayjs(date2).isAfter(dayjs(date3)) &&
            !dayjs(date).isAfter(dayjs(date2)) &&
            (date1 === '' || !dayjs(date1).isAfter(dayjs(date2))) && (
              <Button variant="contained" size="medium" onClick={postTender}>
                Confirm
              </Button>
            )}
          {(date === '' ||
            date2 === '' ||
            date3 === '' ||
            responsiblePerson === '' ||
            dayjs(date2).isAfter(dayjs(date3)) ||
            dayjs(date).isAfter(dayjs(date2)) ||
            (date1 !== '' && dayjs(date1).isAfter(dayjs(date2)))) && (
            <Button variant="contained" size="medium" disabled>
              Confirm
            </Button>
          )}
          {date === '' && (
            <Typography
              variant="caption"
              color="error"
              sx={{ display: 'block', mt: 1 }}
            >
              Internal Deadline date is required
            </Typography>
          )}
          {responsiblePerson === '' && (
            <Typography
              variant="caption"
              color="error"
              sx={{ display: 'block', mt: 1 }}
            >
              Responsible Contact is required
            </Typography>
          )}
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </>
  );
};
export default TenderData;
